{
  "nm": "Flow 2",
  "ddd": 0,
  "h": 693.52,
  "w": 800,
  "meta": {"g": "LottieFiles Figma v112"},
  "layers": [
    {
      "ty": 4,
      "nm": "Mask group",
      "sr": 1,
      "st": 0,
      "op": 73.24,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": {"a": 0, "k": [400, 346.76]},
        "s": {"a": 0, "k": [100, 100]},
        "sk": {"a": 0, "k": 0},
        "p": {"a": 0, "k": [400, 346.76]},
        "r": {"a": 0, "k": 0},
        "sa": {"a": 0, "k": 0},
        "o": {"a": 0, "k": 100}
      },
      "shapes": [],
      "ind": 1
    },
    {
      "ty": 0,
      "nm": "Frame 2",
      "sr": 1,
      "st": 0,
      "op": 73.24,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "td": 1,
      "ao": 0,
      "ks": {
        "a": {"a": 0, "k": [400, 346.76]},
        "s": {"a": 0, "k": [100, 100]},
        "sk": {"a": 0, "k": 0},
        "p": {"a": 0, "k": [400, 346.76]},
        "r": {"a": 0, "k": 0},
        "sa": {"a": 0, "k": 0},
        "o": {"a": 0, "k": 100}
      },
      "w": 800,
      "h": 693.52,
      "refId": "1",
      "ind": 2,
      "parent": 1
    },
    {
      "ty": 4,
      "nm": "Ellipse 1",
      "sr": 1,
      "st": 0,
      "op": 73.24,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "tt": 1,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": {"a": 0, "k": [474, 474]},
        "s": {"a": 0, "k": [100, 100]},
        "sk": {"a": 0, "k": 0},
        "p": {"a": 0, "k": [401, 228]},
        "r": {
          "a": 1,
          "k": [
            {
              "o": {"x": 0.167, "y": 0.167},
              "i": {"x": 0.833, "y": 0.833},
              "s": [180],
              "t": 0
            },
            {
              "o": {"x": 0.167, "y": 0.167},
              "i": {"x": 0.833, "y": 0.833},
              "s": [270],
              "t": 18
            },
            {
              "o": {"x": 0.167, "y": 0.167},
              "i": {"x": 0.833, "y": 0.833},
              "s": [360],
              "t": 36
            },
            {
              "o": {"x": 0.167, "y": 0.167},
              "i": {"x": 0.833, "y": 0.833},
              "s": [450],
              "t": 54
            },
            {"s": [540], "t": 72}
          ]
        },
        "sa": {"a": 0, "k": 0},
        "o": {"a": 0, "k": 100}
      },
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [261.78, 0],
                [0, 261.78],
                [-261.78, 0],
                [0, -261.78]
              ],
              "o": [
                [0, 261.78],
                [-261.78, 0],
                [0, -261.78],
                [261.78, 0],
                [0, 0]
              ],
              "v": [
                [948, 474],
                [474, 948],
                [0, 474],
                [474, 0],
                [948, 474]
              ]
            }
          }
        },
        {
          "ty": "gf",
          "bm": 0,
          "hd": false,
          "nm": "",
          "e": {
            "a": 1,
            "k": [
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 948],
                "t": 0
              },
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 948],
                "t": 18
              },
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 948],
                "t": 36
              },
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 948],
                "t": 54
              },
              {"s": [474, 948], "t": 72}
            ]
          },
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [
                0.25, 0.02356862745098039, 0.7961176470588235,
                0.6745490196078431, 0.75, 0.5529803921568627,
                0.3882745098039216, 0.7686666666666666, 0.25, 1, 0.75, 1
              ]
            }
          },
          "t": 1,
          "a": {"a": 0, "k": 0},
          "h": {"a": 0, "k": 0},
          "s": {
            "a": 1,
            "k": [
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 0],
                "t": 0
              },
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 0],
                "t": 18
              },
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 0],
                "t": 36
              },
              {
                "o": {"x": 0.167, "y": 0.167},
                "i": {"x": 0.833, "y": 0.833},
                "s": [474, 0],
                "t": 54
              },
              {"s": [474, 0], "t": 72}
            ]
          },
          "r": 1,
          "o": {"a": 0, "k": 100}
        }
      ],
      "ind": 3,
      "parent": 1
    }
  ],
  "v": "5.7.0",
  "fr": 60,
  "op": 72.24,
  "ip": 0,
  "assets": [
    {
      "nm": "[Asset] Frame 2",
      "id": "1",
      "fr": 30,
      "layers": [
        {
          "ty": 4,
          "nm": "Frame 2 Bg",
          "sr": 1,
          "st": 0,
          "op": 73.24,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {"a": 0, "k": [400, 346.76]},
            "s": {"a": 0, "k": [100, 100]},
            "sk": {"a": 0, "k": 0},
            "p": {"a": 0, "k": [400, 346.76]},
            "r": {"a": 0, "k": 0},
            "sa": {"a": 0, "k": 0},
            "o": {"a": 0, "k": 100}
          },
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -0.01],
                    [0, 0],
                    [0.01, 0],
                    [0, 0],
                    [0, 0.01],
                    [0, 0],
                    [-0.01, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0.01],
                    [0, 0],
                    [-0.01, 0],
                    [0, 0],
                    [0, -0.01],
                    [0, 0],
                    [0.01, 0]
                  ],
                  "v": [
                    [800, 0.01],
                    [800, 693.51],
                    [799.99, 693.52],
                    [0.01, 693.52],
                    [0, 693.51],
                    [0, 0.01],
                    [0.01, 0],
                    [799.99, 0]
                  ]
                }
              }
            }
          ],
          "ind": 1
        },
        {
          "ty": 4,
          "nm": "Vector",
          "sr": 1,
          "st": 0,
          "op": 73.24,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {"a": 0, "k": [242.56, 260.25]},
            "s": {"a": 0, "k": [100, 100]},
            "sk": {"a": 0, "k": 0},
            "p": {"a": 0, "k": [557.44, 260.26]},
            "r": {"a": 0, "k": 0},
            "sa": {"a": 0, "k": 0},
            "o": {"a": 0, "k": 100}
          },
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [-2.86, 0],
                    [0, 0],
                    [3.07, -5.33],
                    [0, 0],
                    [3.08, 5.34],
                    [0, 0],
                    [-1.43, 2.48],
                    [0, 0]
                  ],
                  "o": [
                    [1.43, -2.48],
                    [0, 0],
                    [6.15, 0],
                    [0, 0],
                    [-3.07, 5.34],
                    [0, 0],
                    [-1.43, -2.48],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [382.8, 4],
                    [389.73, 0],
                    [471.28, 0],
                    [478.21, 11.99],
                    [192.54, 508.47],
                    [178.67, 508.48],
                    [137.42, 437],
                    [137.42, 429],
                    [382.8, 4]
                  ]
                }
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [-1.43, -2.48],
                    [0, 0],
                    [1.41, -2.47],
                    [0, 0],
                    [3.09, 5.35],
                    [0, 0],
                    [-6.16, 0],
                    [0, 0]
                  ],
                  "o": [
                    [2.86, 0],
                    [0, 0],
                    [1.42, 2.46],
                    [0, 0],
                    [-3.06, 5.36],
                    [0, 0],
                    [-3.08, -5.33],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [96.37, 199],
                    [103.31, 203.01],
                    [233.33, 429.02],
                    [233.34, 436.98],
                    [192.52, 508.4],
                    [178.65, 508.43],
                    [6.93, 211],
                    [13.86, 199],
                    [96.37, 199]
                  ]
                }
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "",
              "c": {"a": 0, "k": [1, 1, 1]},
              "r": 1,
              "o": {"a": 0, "k": 100}
            }
          ],
          "ind": 2
        },
        {
          "ty": 4,
          "nm": "Vector",
          "sr": 1,
          "st": 0,
          "op": 73.24,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {"a": 0, "k": [300.61, 346.76]},
            "s": {"a": 0, "k": [100, 100]},
            "sk": {"a": 0, "k": 0},
            "p": {"a": 0, "k": [300.61, 346.76]},
            "r": {"a": 0, "k": 0},
            "sa": {"a": 0, "k": 0},
            "o": {"a": 0, "k": 100}
          },
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [3.08, -5.33],
                    [0, 0],
                    [2.86, 0],
                    [0, 0],
                    [1.43, 2.48],
                    [0, 0],
                    [-6.15, 0],
                    [0, 0]
                  ],
                  "o": [
                    [6.16, 0],
                    [0, 0],
                    [-1.43, 2.48],
                    [0, 0],
                    [-2.86, 0],
                    [0, 0],
                    [-3.07, -5.33],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [587.36, 0.01],
                    [594.29, 12.01],
                    [545.81, 96.01],
                    [538.88, 100.01],
                    [163.13, 100.01],
                    [156.19, 96],
                    [107.89, 12],
                    [114.83, 0.01],
                    [587.36, 0.01]
                  ]
                }
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [-6.16, 0],
                    [0, 0],
                    [-1.43, -2.49],
                    [0, 0],
                    [1.39, -2.46],
                    [0, 0],
                    [3.09, 5.36],
                    [0, 0]
                  ],
                  "o": [
                    [-3.08, -5.33],
                    [0, 0],
                    [2.87, 0],
                    [0, 0],
                    [1.4, 2.45],
                    [0, 0],
                    [-3.05, 5.39],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [6.93, 12],
                    [13.86, 0],
                    [110.87, 0],
                    [117.81, 4.02],
                    [454.21, 590.43],
                    [454.24, 598.35],
                    [407.29, 681.33],
                    [393.4, 681.4],
                    [6.93, 12]
                  ]
                }
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "",
              "c": {"a": 0, "k": [1, 1, 1]},
              "r": 1,
              "o": {"a": 0, "k": 100}
            }
          ],
          "ind": 3
        }
      ]
    }
  ]
}
